import React, { useState } from "react";
import Carousel from "../components/carousel";
import ListProject from "../components/accordion";
import styles from "./projects.module.css";

export default function Projects() {
  const [project, setProject] = useState("");

  return (
    <section id="projects" className={styles.container}>
      <div className={styles["content-projects"]}>
        <ListProject setProject={setProject} />
      </div>
      <div className={styles["content-video"]}>
        {project && <Carousel project={project} styles={styles} />}
      </div>
    </section>
  );
}
